import { DottedName } from '@abc-transitionbascarbone/mon-empreinte-pro-new-model'

export const orderedCategories: DottedName[] = [
  'DT',
  'transport',
  'alimentation',
  'divers',
  'logement',
]
